import React from 'react';
import { List, RootRef } from '@material-ui/core';
import {
  DragDropContext,
  Droppable,
  DroppableProvided,
  DroppableStateSnapshot,
  DropResult,
  DraggableId,
} from '@campfire/draggable-list';
import { FormListItemContext } from './FormListItemContext';
import { FormListItem } from './FormListItem';

export function FormItemList() {
  const { formItems, setFieldValue, setDraggingId } = React.useContext(FormListItemContext);
  const { allIds, byTriggerOption } = formItems;

  const onDragEnd = (result: DropResult) => {
    setDraggingId('');
    const { droppableId: destinationItemId, index: destinationIndex = 0 } = result.destination || {};
    const { droppableId: sourceItemId, index: sourceIndex } = result.source || {};
    const { draggableId } = result;

    if (!sourceItemId || !destinationItemId) {
      return;
    }

    if (sourceItemId === 'root' && destinationItemId === 'root') {
      const itemIds = formItems.allIds.slice();
      itemIds.splice(sourceIndex, 1);
      itemIds.splice(destinationIndex, 0, draggableId);
      setFieldValue('formItems', {
        ...formItems,
        allIds: itemIds,
      });
    }

    if (sourceItemId === 'root' && destinationItemId !== 'root') {
      const itemIds = (formItems.byTrigger[destinationItemId]?.triggerItemIds ?? []).slice();
      itemIds.splice(destinationIndex, 0, draggableId);
      setFieldValue('formItems', {
        ...formItems,
        byTrigger: {
          ...formItems.byTrigger,
          [destinationItemId]: {
            ...formItems.byTrigger[destinationItemId],
            triggerItemIds: itemIds,
          },
        },
        byTriggerOption: {
          ...formItems.byTriggerOption,
          [draggableId]: destinationItemId,
        },
      });
    }

    if (sourceItemId !== 'root' && destinationItemId !== 'root') {
      const sourceItemIds = (formItems.byTrigger[sourceItemId]?.triggerItemIds ?? []).slice();
      sourceItemIds.splice(sourceIndex, 1);
      if (sourceItemId === destinationItemId) {
        sourceItemIds.splice(destinationIndex, 0, draggableId);
        setFieldValue('formItems', {
          ...formItems,
          byTrigger: {
            ...formItems.byTrigger,
            [destinationItemId]: {
              ...formItems.byTrigger[destinationItemId],
              triggerItemIds: sourceItemIds,
            },
          },
          byTriggerOption: {
            ...formItems.byTriggerOption,
            [draggableId]: destinationItemId,
          },
        });
      } else {
        const destinationItemIds = (formItems.byTrigger[destinationItemId]?.triggerItemIds ?? []).slice();
        destinationItemIds.splice(destinationIndex, 0, draggableId);
        setFieldValue('formItems', {
          ...formItems,
          byTrigger: {
            ...formItems.byTrigger,
            [sourceItemId]: {
              ...formItems.byTrigger[sourceItemId],
              triggerItemIds: sourceItemIds,
            },
            [destinationItemId]: {
              ...formItems.byTrigger[destinationItemId],
              triggerItemIds: destinationItemIds,
            },
          },
          byTriggerOption: {
            ...formItems.byTriggerOption,
            [draggableId]: destinationItemId,
          },
        });
      }
    }
  };
  const onBeforeCapture = ({ draggableId }: { draggableId: DraggableId }) => {
    setDraggingId(draggableId);
  };

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd} onBeforeCapture={onBeforeCapture}>
        <Droppable droppableId='root'>
          {(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => {
            const style = { paddingBottom: '2rem' };
            const updatedStyle = snapshot.isDraggingOver ? { pointerEvents: 'none', ...style } : style;
            return (
              <RootRef rootRef={provided.innerRef}>
                <List style={updatedStyle as React.CSSProperties}>
                  {allIds.map((formItemId, index) => {
                    if (byTriggerOption[formItemId]) {
                      return <div style={{ display: 'none' }} key={formItemId}></div>;
                    }
                    return <FormListItem formItemId={formItemId} index={index} key={formItemId} />;
                  })}
                  {provided.placeholder}
                </List>
              </RootRef>
            );
          }}
        </Droppable>
      </DragDropContext>
    </>
  );
}
